export default __webpack_public_path__ + "static/media/CompanyIcon.a48fd8ab.svg";